export function currency( value ) {
  return parseFloat( value.toFixed( 2 ) );
}

